import * as React from "react"
const CancelSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={window.screen.width <= 1000 ? '25' : '30'}
    height={window.screen.width <= 1000 ? '30' : '40'}
    fill={'whitesmoke'}
    viewBox="0 0 512.021 512.021"
    
    {...props}
  >
    <path d="M301.258 256.01 502.645 54.645c12.501-12.501 12.501-32.769 0-45.269-12.501-12.501-32.769-12.501-45.269 0L256.01 210.762 54.645 9.376c-12.501-12.501-32.769-12.501-45.269 0s-12.501 32.769 0 45.269L210.762 256.01 9.376 457.376c-12.501 12.501-12.501 32.769 0 45.269s32.769 12.501 45.269 0L256.01 301.258l201.365 201.387c12.501 12.501 32.769 12.501 45.269 0 12.501-12.501 12.501-32.769 0-45.269L301.258 256.01z" />
  </svg>
)
export default CancelSVG;
